import { Popup, PopupProps } from 'lib/classes/popup';
import { assetURL } from 'lib/utilities/asset';
import { getLocaleString } from 'lib/localization/vendor';

import LaunchIcon from '@mui/icons-material/Launch';

const ConsultationPopup = new Popup({
	title: () => getLocaleString('consultation-info'),
	style: {minWidth: 350},
	render: function() {
		const mapConfig:any = this.get('map-config');
		const rows:any[] = [];
		
		mapConfig.consultation.links.forEach((link:any) => {
			const { url, title } = link;
			
			rows.push(
				<div className='linked-resource' key={rows.length}>
					<a href={url} target='_blank'>
						<LaunchIcon /> {title} 
					</a>
					<div className='gray-label small'>
						<i>{url}</i>
					</div>
				</div>
			)
		});
		
		return rows;
	}
});

export default ConsultationPopup;